import { render } from "./TagLevelSetting.vue?vue&type=template&id=b2486304&scoped=true"
import script from "./TagLevelSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./TagLevelSetting.vue?vue&type=script&setup=true&lang=js"

import "./TagLevelSetting.vue?vue&type=style&index=0&id=b2486304&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2486304"],['__file',"src/views/jbh/achievementManage/accountSafetyLevelSetting/TagLevelSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2486304"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2486304', __exports__)) {
    console.log('reload')
    api.reload('b2486304', __exports__)
  }
  
  module.hot.accept("./TagLevelSetting.vue?vue&type=template&id=b2486304&scoped=true", () => {
    console.log('re-render')
    api.rerender('b2486304', render)
  })

}


export default __exports__